import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";

// Suppress socket-related error toasts (WebSocket transport noise)
function isSocketErrorToast(title?: React.ReactNode, description?: React.ReactNode): boolean {
  const combined = `${title ?? ''} ${description ?? ''}`;
  return /socket\s*error/i.test(combined);
}

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        // Filter out socket error toasts
        if (isSocketErrorToast(title, description)) {
          console.warn('[Toaster] Suppressed socket error toast:', title, description);
          return null;
        }
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
